import { apiErrorHandler } from '../../errors/api-error-handler';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import GetBooksAndBestsellersService from "../../services/getbooks-and-bestsellers.service"
import { GetBooksAndBestsellersInitialStateType, GetBooksAndBestsellersType } from '../../models/getbooks-and-bestsellers-model';

const initialState: GetBooksAndBestsellersInitialStateType = {
    BestsellersData: [],
    AllBooksInfoData: [],
    GetBooksAndBestsellersLoading: true,  
    GetBooksAndBestsellersError: undefined,
} ;

export const retrieveBestSellers = createAsyncThunk('retrieveBestSellers/retrieve',
    async (__data, { rejectWithValue }) => {
        try {
            const response = await GetBooksAndBestsellersService.getAllGetBooksAndBestsellers('best-sellers')
            return [response.data]
        
        } catch (error: any) {
            if (!error.response) {
                throw error
              }
            return rejectWithValue(error.response.status)
            
        }
        
    }
)

const BestSellersSlice = createSlice({
    name: 'retrieveBestSellers',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(retrieveBestSellers.pending, (state) => {
                    state.GetBooksAndBestsellersLoading = true;
            })
            .addCase(retrieveBestSellers.fulfilled, (state, action) => {
                if(action.payload){
                    state.GetBooksAndBestsellersLoading = false;
                    state.BestsellersData = action.payload as GetBooksAndBestsellersType[];
                }   
            })        
            .addCase(retrieveBestSellers.rejected, (state, {payload}) => {
                    state.GetBooksAndBestsellersLoading = false;
                    state.GetBooksAndBestsellersError = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default BestSellersSlice.reducer;
